var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('div',{staticClass:"about text-center"},[_c('img',{attrs:{"src":require("../../assets/logo.png"),"alt":""}}),_c('h1',[_vm._v("About")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }